<template>
  <DBox
    :addButton="false"
    :addLink="false"
    :id="'cmp-booking-artists-artist-urls'"
  >
    <Dropdown2
      :label="$t('vat_type_string')"
      :placeholder="$t('vat_type_string')"
      :options="vatTypes"
      :selected="vatTypes.find((e) => e.value == selectedArtist.vat_type_id)"
      v-on:selectedChange="(e) => onDropdownChange('vat_type_id', e)"
      lw="40%"
    />
    <TextField2
      id="cost_center"
      :placeholder="$t('cost_center')"
      :label="$t('cost_center')"
      :value="selectedArtist.cost_center"
      :disabled="false"
      @blur="(e) => onTextFieldValueChange(e)"
      lw="40%"
    />
    <TextField2
      id="default_agent_commission"
      :placeholder="$t('default_agent_commission')"
      :label="$t('default_agent_commission')"
      :value="selectedArtist.default_agent_commission"
      :disabled="false"      
      bb="0px"
      @blur="(e) => onTextFieldValueChange(e)"
      lw="40%"
      :type="'percent'"
    />
  </DBox>
</template>

<script>
import TextField from "@plugins/text-field/text-field";
import { createValidator } from "@plugins/text-field";

import isEmail from "validator/lib/isEmail";

import Dropdown from "@plugins/dropdown/dropdown";
import { EventHooks } from "../../../../../plugins/text-field";

export default {
  components: {
    TextField,
    Dropdown,
  },
  props: ["selectedArtist"],
  data: function () {
    return {
      vatTypes: [
        { text: "Full VAT", value: 1 },
        { text: "Half VAT", value: 2 },
        { text: "No VAT", value: 3 },
      ],

      // textFieldConfig: {
      //   height: 42,
      //   showEditIconOnHover: false,
      //   box: true,
      //   showValidationIcons: true,

      //   validationEvent: EventHooks.OnBlur,
      //   valueChangedEvent: EventHooks.OnBlur,
      // },
      // validationResult: {},
    };
  },
  mounted: function () {},
  computed: {
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
  },
  methods: {
    onTextFieldValueChange: function (event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function (name, event) {
      this.$emit("changed", { name, value: event.value });
    },
    onValidation: function (name, value) {
      // this.$set(this.validationResult, name, value);
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>

<style lang="scss" scoped>
// .form-group {
//   display: flex;
//   flex-direction: column;
//   margin: 5px;

//   .dt-input-box--container {
//     flex: 1;
//     --tf-margin: 5px 0px;
//   }

//   .group-input {
//     margin-top: 25px;
//     margin-bottom: 10px;
//     margin-right: 5px;
//   }
// }

// .dt-modal--options {
//   button {
//     height: 30px;
//   }
// }
</style>
